var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Technology/folder/closed"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.33337 11.6665H25.6667M2.33337 20.9998V6.99984C2.33337 5.71117 3.37804 4.6665 4.66671 4.6665H8.36688C8.98571 4.6665 9.57921 4.91234 10.0168 5.34992L10.9833 6.31642C11.4209 6.75401 12.0144 6.99984 12.6332 6.99984H23.3334C24.622 6.99984 25.6667 8.04451 25.6667 9.33317V20.9998C25.6667 22.2885 24.622 23.3332 23.3334 23.3332H4.66671C3.37804 23.3332 2.33337 22.2885 2.33337 20.9998Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosed);
export default __webpack_public_path__ + "static/media/closed.5828c904b0744508b0f21697b6524159.svg";
export { ForwardRef as ReactComponent };